import "vue-material/dist/vue-material.min.css";
import "./assets/scss/material-dashboard.scss";

import VueMaterial from "vue-material"

export default {
    install(Vue) {
      Vue.use(VueMaterial);
    }
  };
